import React from 'react';

import type { FC } from 'react';

export const Add: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M23.9993 17.3334H17.3327V24C17.3327 24.7334 16.7327 25.3334 15.9993 25.3334C15.266 25.3334 14.666 24.7334 14.666 24V17.3334H7.99935C7.26602 17.3334 6.66602 16.7334 6.66602 16C6.66602 15.2667 7.26602 14.6667 7.99935 14.6667H14.666V8.00002C14.666 7.26669 15.266 6.66669 15.9993 6.66669C16.7327 6.66669 17.3327 7.26669 17.3327 8.00002V14.6667H23.9993C24.7327 14.6667 25.3327 15.2667 25.3327 16C25.3327 16.7334 24.7327 17.3334 23.9993 17.3334Z" />
    </svg>
  );
};
